module.exports = __webpack_public_path__ + "static/media/close-icon.777b93c6.svg";